import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { SiteServices } from '../../services/siteservices';
import {
    ProgressbarModule,
    ModalModule,
    BsDatepickerModule,
    DatepickerModule,
} from 'ngx-bootstrap';

import { AlertModule } from 'ngx-bootstrap/alert';

//import { ChipsModule, InputTextModule } from '../../lib/primeng/primeng';
import { ProviderComponent } from './provider.main';
import { ModalDialogModule } from 'ngx-modal-dialog';
import { FileUploadModule } from 'ng2-file-upload';
import { PROVIDER_ROUTER } from './provider.routes';
import { EnvironmentServices } from '../../services/evironment.service';

@NgModule({
    declarations: [ProviderComponent],
    imports: [
        BrowserModule,
        FormsModule,
        HttpModule,
        PROVIDER_ROUTER,
        AlertModule.forRoot(),
        ProgressbarModule.forRoot(),
        ModalModule.forRoot(),
        ModalDialogModule.forRoot(),
        FileUploadModule,
        BsDatepickerModule.forRoot(),
        DatepickerModule.forRoot(),
    ],
    providers: [SiteServices, EnvironmentServices],

    bootstrap: [ProviderComponent],
})
export class ProviderModule {}
